import { Link } from 'react-router-dom'
import artworksData from '../../data/artworks.json'
import Section from '../common/Section'

export default function FeaturedWorks() {
  // Get only featured artworks
  const featuredArtworks = artworksData.artworks.filter(artwork => artwork.featured)

  return (
    <Section background="neutral" padding="large">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif text-primary mb-4">
            Ausgewählte Werke
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
            Eine Auswahl meiner aktuellen Arbeiten in zeitgenössischer Acryl-Technik
          </p>
        </div>

        {/* Featured Artworks Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredArtworks.map(artwork => (
            <Link
              key={artwork.id}
              to={`/werke/${artwork.id}`}
              className="group block bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              {/* Artwork Image */}
              <div className="aspect-square overflow-hidden bg-neutral-100">
                <picture>
                  <source
                    srcSet={artwork.images[0].medium}
                    type="image/webp"
                  />
                  <img
                    src={artwork.images[0].fallback}
                    alt={artwork.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </picture>
              </div>

              {/* Artwork Info */}
              <div className="p-6">
                <h3 className="text-xl font-serif text-primary mb-2 group-hover:text-secondary transition-colors">
                  {artwork.title}
                </h3>
                <div className="text-sm text-neutral-600 space-y-1">
                  <p>{artwork.year}</p>
                  <p>{artwork.medium}</p>
                  <p>
                    {artwork.dimensions.width} × {artwork.dimensions.height} cm
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-12">
          <Link
            to="/werke"
            className="inline-flex items-center text-primary hover:text-secondary font-medium text-lg transition-colors group"
          >
            Alle Werke ansehen
            <svg
              className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
        </div>
      </div>
    </Section>
  )
}
